export const retailIndData = [
    'ASSIGN',
    'NONASN',
    'RETAIL',
    'RENTAL'
];

export const specialAcctData = [
    'DEMO',
    'GOVT',
    'PROMO'
];

export const unitCodeData = [
    'REGION 1',
    'REGION 2',
    'N/A'
];

export const sortFieldName = ind => {

    if ( ind === 1 ) return 'sortfieldTwo';
    if ( ind === 2 ) return 'sortfieldThree';
    if ( ind === 3 ) return 'sortfieldFour';
    return 'sortfieldOne';

};
